import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Link,
  Select,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { XIcon, CheckIcon } from "@shopify/polaris-icons";
import Select2 from "react-select";

const RequestDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const [selectedProfessor, setSelectedProfessor] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleSelectChangeProfessor = (newValue) => {
    setSelectedProfessor(newValue);
    setProfessorError("");
  };
  const [professorError, setProfessorError] = useState("");
  const [dateValue, setDateValue] = useState("");
  const handleChangeDate = (newValue) => {
    setDateValue(newValue);
  };
  const [timeValue, setTimeValue] = useState("");
  const handleChangeTime = (newValue) => {
    setTimeValue(newValue);
  };
  const [meetingLingValue, setMeetingLingValue] = useState("");
  const handleChangeMeetingLink = (newValue) => {
    setMeetingLingValue(newValue);
  };
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalReject, setActiveModalReject] = useState(false);
  const [activeModalApprove, setActiveModalApprove] = useState(false);
  const [ts, setTs] = useState("");

  const handleSubmit = () => {
    if (selectedProfessor === "") {
      setProfessorError("Please choose a professor");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("_method", "PATCH");
      form_data.append("status", 2);
      dateValue && form_data.append("date", dateValue);
      timeValue && form_data.append("time", timeValue);
      form_data.append("meeting_link", meetingLingValue);
      form_data.append("professor_id", selectedProfessor);
      setIsSaving(true);
      axios
        .post(`/requests/${id}/edit-status`, form_data)
        .then((result) => {
          setIsSaving(false);
          setActiveModal(false);
          setTs(+new Date());
        })
        .catch((err) => console.log(err));
    }
  };
  const handleReject = () => {
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 3);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModalReject(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleApprove = () => {};
  const handleChangeModal = () => {
    setActiveModal(false);
  };

  const handleChangeModalReject = () => {
    setActiveModalReject(false);
  };
  const handleChangeModalApprove = () => {
    setActiveModalApprove(false);
  };
  const [result, setResult] = useState("");
  useEffect(() => {
    fetchData();
  }, [ts]);

  async function fetchData() {
    let responseProfessors = "";
    let responseItem = "";

    try {
      responseItem = await axios.get(`/requests/${id}`);

      setResult(responseItem.data.data);
      responseItem.data.data.professor &&
        responseItem.data.data.professor.id !== null &&
        setSelectedProfessor(String(responseItem.data.data.professor.id));
    } catch (error) {
      console.log(error);
    }

    try {
      responseProfessors = await axios.get(
        `/professors${
          responseItem?.data?.data.subject
            ? `?filter[subjects.id]=${responseItem?.data?.data.subject.id}`
            : ""
        }`
      );
      setOptionsProfessors(
        responseProfessors.data.data.data.map((item, index) => {
          return {
            label: item?.name && getFirstNonNullValue(item.name),
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  const switchStatusColor = (param) => {
    switch (String(param)) {
      case "1":
        return "default";
      case "2":
        return "success";
      case "3":
        return "critical";
      default:
        return "";
    }
  };
  return result ? (
    <Page
      // narrowWidth
      backAction={{ onAction: () => navigate("/admin/requests") }}
      title={result?.user?.name}
      titleMetadata={
        <Badge tone={switchStatusColor(result?.status?.id)}>
          {result?.status?.description}
        </Badge>
      }
      secondaryActions={[
        {
          content: "Approve",
          icon: CheckIcon,
          disabled:
            result?.status?.description === "Approved" ||
            result?.status?.description === "Rejected",
          onAction: () => {
            setActiveModal(true);
          },
        },
        {
          content: "Reject",
          destructive: true,
          icon: XIcon,
          disabled:
            result?.status?.description === "Approved" ||
            result?.status?.description === "Rejected",
          onAction: () => {
            setActiveModalReject(true);
          },
        },
      ]}
    >
      <Card>
        <FormLayout>
          <FormLayout.Group condensed>
            <Text breakWord>
              <b>Name</b>
              <br /> {result?.user?.name ? result?.user?.name : "-"}
            </Text>
            <Text breakWord>
              <b>Email</b>
              <br /> {result?.user?.email ? result?.user?.email : "-"}
            </Text>
            <Text breakWord>
              <b>Phone</b>
              <br /> {result?.user?.phone ? result?.user?.phone : "-"}
            </Text>
          </FormLayout.Group>
          <FormLayout.Group condensed>
            <Text breakWord>
              <b>Professor</b>
              <br />
              {result?.professor && result?.professor?.name
                ? getFirstNonNullValue(result?.professor?.name)
                : "-"}
            </Text>

            <Text breakWord>
              <b>Subject</b>
              <br />
              {result?.subject && result?.subject?.name
                ? getFirstNonNullValue(result?.subject?.name)
                : "-"}
            </Text>

            <Text />
          </FormLayout.Group>
          <FormLayout.Group condensed>
            <Text breakWord>
              <b>Date</b>
              <br /> {result?.date ? result?.date : "-"}
            </Text>
            <Text breakWord>
              <b>Time</b>
              <br /> {result?.time ? result?.time : "-"}
            </Text>
            <Text breakWord>
              <b>Meeting Link</b>
              <br /> {result?.meeting_link ? result?.meeting_link : "-"}
            </Text>
          </FormLayout.Group>
        </FormLayout>
      </Card>

      <Modal
        open={activeModal}
        onClose={handleChangeModal}
        title="Approve Request"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            loading: isSaving,
            onAction: handleChangeModal,
          },
        ]}
      >
        <Modal.Section>
          <FormLayout>
            <Select
              label="Please assign a professor"
              options={optionsProfessors}
              onChange={handleSelectChangeProfessor}
              value={selectedProfessor}
              placeholder="Please select"
              error={professorError}
            />
            <FormLayout.Group>
              <TextField
                label="Date"
                value={dateValue ? dateValue : result.date}
                onChange={handleChangeDate}
                type="date"
              />
              <TextField
                label="Time"
                value={timeValue ? timeValue : result.time}
                onChange={handleChangeTime}
                type="time"
              />
              <TextField
                label="Meeting Link"
                value={meetingLingValue}
                onChange={handleChangeMeetingLink}
              />
            </FormLayout.Group>
          </FormLayout>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalReject}
        onClose={handleChangeModalReject}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleReject,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalReject,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalApprove}
        onClose={handleChangeModalApprove}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleApprove,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalApprove,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default RequestDetails;
